import React, { useState } from "react";
import { toast } from "react-toastify";
import AsyncSelect from "react-select/async";
import _ from "lodash";
import { api } from "../utils";

export default function BOMTypeahead(props) {
   const [inputValue, setInputValue] = useState("");
   const [working, setWorking] = useState(false);

   const loadOptions = (typedValue, callback) => {
      if (!typedValue || !typedValue.length || typedValue.length < 2) {
         return;
      }
      const payload = { searchTerm: typedValue, itemGroup: props.itemGroup, includeSamples: props.includeSamples };
      setWorking(true);
      api
         .fetch("BOM/Typeahead", payload)
         .then((response) => {
            _.forEach(response.data.message, (d) => {
               d.label = d.itemWithDesc;
               d.value = d.itemNumber;
            });
            callback(response.data.message);
         })
         .catch(() => {
            toast.error("There was an error loading item information.");
            callback([]);
         })
         .finally(() => setWorking(false));
   }

   return (
      <AsyncSelect
         classNamePrefix='serviceThreadSelect'
         className={props.className}
         loadOptions={loadOptions}
         onChange={props.onChange}
         onInputChange={(e) => setInputValue(e)}
         inputValue={inputValue}
         value={props.value}
         onFocus={props.onFocus}
         placeholder={props.placeholder || "Type the item number you are looking for"}
         isDisabled={props.isDisabled}
         isClearable
         isLoading={working}
      />);
} 